module.exports = __webpack_public_path__ + "img/y-so-serious.870cc21c.png";